<template>
    <div>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Online Outstanding Fees Payment</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
                <v-row justify="center">
                    AY ::{{current_ay}} || Standard :: {{leaner_std}} || Division :: {{leaner_div}}
                </v-row>
                <v-data-table :headers="headers" :items="student_outstanding_fees_list" dense class="mytable elevation-1" :search="search">
                    <template v-slot:item.action="{ item }">
                        <span class="text" v-if="item.balance > 0">
                        <!-- <form :action="url" @submit="payment" name="paytmform"  method="POST">
                                <input type="hidden" :value="item.orgid" name="orgid" />
                                <input type="hidden" :value="item.tenantid" name="tenantid" />
                                <input type="hidden" :value="item.uid" name="uid" />
                                <input type="hidden" :value="item.learner_id" name="studid" />
                                <input type="hidden" :value="item.pay_fee" name="fee_amount"/>
                                <input type="hidden" :value="item.outstanding_fee_id" name="json_pre_trans_data"/>
                                <input type="hidden" :value="item.hash_val" name="hash_val"/>
                                 <input type="hidden" value="OF" name="p_type"/>
                                <v-btn small class="button" type="submit" :loading="loader" :disabled="item.pay_fee == 0 || flag_disable">Proceed</v-btn>  
                            </form> -->
                            <v-btn small class="button" @click="proceed(item.learner_id,item.outstanding_fee_id,item.pay_fee,item.of_academicyear)" :loading="loader" :disabled="item.pay_fee == 0 || flag_disable">Proceed</v-btn>  
                        </span>
                        <span v-else class="text">
                             <strong>Already Paid</strong>
                        </span>        
                    </template>
                    <template v-slot:item.pay_fee="{ item }">
                    <div v-if="item.balance > 0">
                        <v-text-field class="mt-1 pt-1" @change="checkfee(item.pay_fee,item.balance)" rounded label="Enter Amount" hide-details="auto" v-model="item.pay_fee" outlined dense></v-text-field>
                    </div>
                      <div v-else class="text">
                        <strong>Already Paid</strong>
                    </div>
                </template>
                </v-data-table>
        </v-card>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        props: {
            selected_children: String,
        },
        data: () => ({
            child_info: null,
            children: [],
            selected_install: [],
            get_component_installmet_list: [],
            show: false,
            selected_children: "",
            child_notice: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            flag_disable:false,
            current_ay: "",
             leaner_div:null,
            leaner_std:null,
            search: "",
            s3url: "",
            misc_fees_list:"",
            url:"",
            student_outstanding_fees_list: [],
            payment_modes: [],
            select_mode: "",
            new_input: "",
            student_receipts:[],
            headers: [
                { text: "Sr. No.", value: "srno" },
                { text: "PRN No.", value: "stud_reg_no", align: "center" },
                { text: "Academic Year", value: "of_academicyear" },
                { text: "Fees", value: "fee" },
                { text: "Paid Fees", value: "paid_fee" },
                { text: "Balance", value: "balance" },
                { text: "Amount", value: "pay_fee" },
                { text: "Pay", value: "action", align: "center" },
            ],
        }),
         created(){
         this.url=process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_outstanding"
    },
        methods: {
            checkfee(pay_fee,balance){
               // alert(pay_fee + "----"+balance)
                if(pay_fee > balance){
                 //   alert("in if")
                     this.showSnackbar("#b71c1c", "Amount should be less than balance amount");
                     this.flag_disable = true
                     return
                }
                else{
                    this.flag_disable = false
                }
            },
             payFees() {
                 //alert("alert in payfee")
                 //alert(this.returnURL)
                    bdPayment.initialize({
                        msg: this.checksumurl,
                        callbackUrl: this.returnURL,
                        options: {
                            enableChildWindowPosting: true,
                            enablePaymentRetry: true,
                            retry_attempt_count: 2,
                        },
                    });
                },
             proceed(learner_id,outstanding_fee_id,fee_amount,of_academicyear){
                const data = {
                    learner_id : learner_id,
                    outstanding_fee_id : outstanding_fee_id,
                    fee_amount : fee_amount,
                    json_pre_trans_data : outstanding_fee_id,
                    purpose : of_academicyear
                }
                axios
                .post("/OutstandingFees/getOutstandingPaymentInfoBillDesk", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.checksumurl = res.data.checksumurl;
                            this.returnURL = res.data.returnURL;
                            this.payFees()
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            getDetails() {
                const formData = {
                    registration_no: this.selected_children.registration_number,
                };
                this.overlay = true;
                axios
                    .post("OutstandingFees/getLearnerData", formData)
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.flag == "YES") {
                             this.show = true;
                            this.student_outstanding_fees_list = res.data.array_of_sof;
                            this.payment_modes = res.data.payment_modes;
                            this.student_receipts = res.data.student_receipts
                            this.current_ay = res.data.current_ay;
                            this.leaner_std = res.data.leaner_std;
                            this.leaner_div = res.data.leaner_div;
                            this.loader=false
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        }
                    })
                    .catch((error) => {
                        this.overlay = false;
                        this.loader=false
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.loader=false
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
           this. getDetails()
        },
    };
</script>

<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .text{
   color: red !important;
}
</style>
